<template>
  <div class="standart_field" :class="id">
    <label :for="id" v-show="title != '' && title != null">{{title}}</label>
    <div class="input_area">

      <input
          :id="id" :placeholder="placeholder"
          :type="inputType"
          :class="[{error: errorText != '' && errorText != null}]"
          :disabled="disabled"
          :value="value" @input="updateValue"
          v-if="mask == null || mask == ''"
      >

      <MaskInput
          :id="id" :placeholder="placeholder"
          :class="[{error: errorText != '' && errorText != null}]"
          :disabled="disabled"
          :mask="mask"
          :value="value" @change="updateValue"
          v-if="mask != null && mask != ''"
      />

      <div v-show="showEye" class="eye" @click="toggleEyeState()">
        <svg v-show="!eyeState" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M18.2173 8.00645C19.2609 9.13937 19.2609 10.8606 18.2173 11.9935C16.4571 13.9043 13.434 16.5 10 16.5C6.56604 16.5 3.54294 13.9043 1.78274 11.9936C0.739089 10.8606 0.739088 9.13937 1.78273 8.00645C3.54294 6.09567 6.56604 3.5 10 3.5C13.434 3.5 16.4571 6.09567 18.2173 8.00645Z" stroke="#656565" stroke-width="1.5"/>
          <path d="M12.7 10C12.7 11.5385 11.4912 12.7857 10 12.7857C8.50883 12.7857 7.3 11.5385 7.3 10C7.3 8.46149 8.50883 7.21429 10 7.21429C11.4912 7.21429 12.7 8.46149 12.7 10Z" stroke="#656565" stroke-width="1.5"/>
        </svg>
        <svg v-show="eyeState" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M2.8 3L17.2 17M11.8 11.9566C11.3223 12.3723 10.6915 12.625 10 12.625C8.50883 12.625 7.3 11.4497 7.3 10C7.3 9.32769 7.55997 8.71441 7.9875 8.25M16.847 13.1567C17.3612 12.7215 17.8212 12.2837 18.2173 11.8785C19.2609 10.811 19.2609 9.18903 18.2173 8.12146C16.4571 6.32092 13.434 3.875 10 3.875C9.19776 3.875 8.41795 4.00849 7.67143 4.23606M5.05 5.45296C3.73729 6.26763 2.61787 7.26719 1.78274 8.12146C0.739089 9.18902 0.739088 10.811 1.78273 11.8785C3.54294 13.6791 6.56604 16.125 10 16.125C11.6813 16.125 13.2641 15.5387 14.6484 14.7289" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>

      <div class="icon" v-show="icon != ''">
        <svg class="calendar" v-show="icon == 'calendar'" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
          <path d="M14 1.66667V3.33334M4 1.66667V3.33334" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.9961 10.8333H9.00358M8.9961 14.1667H9.00358M12.3257 10.8333H12.3332M5.6665 10.8333H5.67398M5.6665 14.1667H5.67398" stroke="#1B78BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.9165 6.66667H16.0832" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.08325 10.2027C1.08325 6.57161 1.08325 4.75607 2.12668 3.62803C3.17012 2.5 4.84949 2.5 8.20825 2.5H9.79158C13.1503 2.5 14.8297 2.5 15.8732 3.62803C16.9166 4.75607 16.9166 6.57161 16.9166 10.2027V10.6306C16.9166 14.2617 16.9166 16.0773 15.8732 17.2053C14.8297 18.3333 13.1503 18.3333 9.79158 18.3333H8.20825C4.84949 18.3333 3.17012 18.3333 2.12668 17.2053C1.08325 16.0773 1.08325 14.2617 1.08325 10.6306V10.2027Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.5 6.66667H16.5" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

    </div>

    <div class="error-text" v-show="errorText != '' && errorText != null">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 1.5C4.41594 1.5 1.5 4.41594 1.5 8C1.5 11.5841 4.41594 14.5 8 14.5C11.5841 14.5 14.5 11.5841 14.5 8C14.5 4.41594 11.5841 1.5 8 1.5ZM8 11.4972C7.87639 11.4972 7.75555 11.4605 7.65277 11.3919C7.54999 11.3232 7.46988 11.2256 7.42258 11.1114C7.37527 10.9972 7.36289 10.8715 7.38701 10.7503C7.41112 10.629 7.47065 10.5177 7.55806 10.4302C7.64547 10.3428 7.75683 10.2833 7.87807 10.2592C7.99931 10.2351 8.12497 10.2475 8.23918 10.2948C8.35338 10.3421 8.45099 10.4222 8.51967 10.525C8.58834 10.6277 8.625 10.7486 8.625 10.8722C8.625 11.0379 8.55915 11.1969 8.44194 11.3141C8.32473 11.4313 8.16576 11.4972 8 11.4972ZM8.67875 5.21125L8.49938 9.02375C8.49938 9.15636 8.4467 9.28354 8.35293 9.3773C8.25916 9.47107 8.13198 9.52375 7.99937 9.52375C7.86677 9.52375 7.73959 9.47107 7.64582 9.3773C7.55205 9.28354 7.49937 9.15636 7.49937 9.02375L7.32 5.21313V5.21156C7.31607 5.11998 7.33071 5.02854 7.36305 4.94277C7.39539 4.85699 7.44475 4.77865 7.50817 4.71245C7.57158 4.64626 7.64774 4.59358 7.73205 4.55759C7.81636 4.5216 7.90708 4.50305 7.99875 4.50305C8.09042 4.50305 8.18114 4.5216 8.26545 4.55759C8.34976 4.59358 8.42592 4.64626 8.48933 4.71245C8.55275 4.77865 8.60211 4.85699 8.63445 4.94277C8.66679 5.02854 8.68143 5.11998 8.6775 5.21156L8.67875 5.21125Z" fill="#FA4B61"/>
      </svg>
      <span>{{errorText}}</span>
    </div>
  </div>
</template>

<script>

import { MaskInput } from 'vue-3-mask';

export default {
  name : "StandartFiled",
  props : {
    id : String,
    title : String,
    type : String,
    placeholder : String,
    value : String,
    errorText: String,
    icon: String,
    disabled: Boolean,
    mask: String
  },
  components: {
    MaskInput
  },
  data() {
    return{
      showEye: this.type == "password",
      eyeState: false,

      inputType: this.type
    }
  },
  methods: {
    updateValue(e) {
      this.$emit("updated", e.target.value);
    },
    toggleEyeState : function () {
      if(!this.eyeState) {
        this.eyeState = true;
        this.inputType = "text";
      } else {
        this.eyeState = false;
        this.inputType = "password";
      }
    }
  }
}
</script>

<style scoped>
.standart_field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.standart_field label {
  cursor: pointer;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  padding-left: 20px;
}

.input_area {
  position: relative;
}

.standart_field input {
  padding: 15px 20px;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  outline: none;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  width: 100%;
  box-sizing: border-box;
}

.standart_field input[disabled] {
  color: var(--Gray, #656565);
}

.standart_field input.error {
  border: 1px solid var(--Red, #FA4B61);
}

.eye {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 20px;
  display: flex;
}

input::-ms-reveal,
input::-ms-clear {
  display: none;
}

.icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 20px;
  display: flex;
}

.error-text {
  display: flex;
  gap: 8px;
}

.error-text svg{
  width: 16px;
  height: 16px;
}

.error-text span {
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  flex: 1;
}
</style>